import { registerInit } from "./initRegistry";
// @ts-ignore
import LZString = require("lz-string");

interface DiffItem {
    [key: string]: string | undefined;
    "js-cart-main-image"?: string;
    "js-cart-title"?: string;
    "js-cart-price"?: string;
    "js-cart-old-price"?: string;

    "js-cart-href"?: string;
    "js-cart-sku"?: string;
    "js-cart-width"?: string;
    "js-cart-height"?: string;
    "js-cart-weight"?: string;
    "js-cart-length"?: string;
    "js-cart-minimum"?: string;
    "js-cart-unit-price"?: string;
}

export function initDifference(): void {
    const favoritesContainer = document.querySelector(".js-difference") as HTMLElement | null;
    if (!favoritesContainer) return;

    const printLink = document.querySelector(".js-print") as HTMLAnchorElement | HTMLButtonElement | null;
    if (printLink) {
        printLink.addEventListener("click", () => {
            window.print();
        });
    }

    const btn = document.querySelector(".js-share") as HTMLButtonElement | HTMLAnchorElement | null;
    if (!btn) return;

    btn.addEventListener("click", () => {
        try {
            const storedCart = localStorage.getItem("diff") || "{}";
            let diffObj: Record<string, DiffItem>;

            try {
                diffObj = JSON.parse(storedCart) as Record<string, DiffItem>;
            } catch {
                diffObj = {};
            }

            const ids = Object.keys(diffObj || {});
            const payload = JSON.stringify({ ids });
            const compressed = LZString.compressToEncodedURIComponent(payload);
            const url = "https://gbi-etalon.ru/difference?share=" + compressed;

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).catch(err => {
                    console.error("Clipboard error:", err);
                    window.prompt("Скопируйте ссылку вручную:", url);
                });
            } else {
                window.prompt("Скопируйте ссылку вручную:", url);
            }
        } catch (err) {
            console.error("Share error:", err);
        }
    });

    const itemsContainer = document.querySelector(".items") as HTMLElement | null;
    const emptyContainer = document.querySelector(".container-empty") as HTMLElement | null;
    const diffWrapper = document.querySelector(".diff-wrapper") as HTMLElement | null;

    function renderSelectedCharacteristicsTable(diffObj: Record<string, DiffItem>): void {
        const tableRoot = document.querySelector(".diff-table") as HTMLElement | null;
        if (!tableRoot) return;

        const tableBody = tableRoot.querySelector(".table") as HTMLElement | null;
        if (!tableBody) return;

        const ids = Object.keys(diffObj || {});
        if (!ids.length) {
            tableBody.innerHTML = "";
            tableRoot.style.display = "none";
            return;
        }

        tableRoot.style.display = "block";
        tableBody.innerHTML = "";

        const rows: { label: string; key: keyof DiffItem | string }[] = [
            { label: "Наименование", key: "js-cart-title" },
            { label: "Длина",        key: "js-cart-length" },
            { label: "Высота",       key: "js-cart-height" },
            { label: "Ширина",       key: "js-cart-width" },
            { label: "Вес",          key: "js-cart-weight" },
        ];

        rows.forEach(row => {
            const tr = document.createElement("div");
            tr.className = "tr";

            // первая ячейка — название характеристики
            const firstTd = document.createElement("div");
            firstTd.className = "td";
            firstTd.textContent = row.label;
            tr.appendChild(firstTd);

            // дальше — по одному td на каждый товар
            ids.forEach(id => {
                const item = diffObj[id];
                const td = document.createElement("div");
                td.className = "td";

                if (!item) {
                    td.textContent = "-";
                } else {
                    let value = (item[row.key as keyof DiffItem] as string) || "";

                    if (
                        row.key === "js-cart-length" ||
                        row.key === "js-cart-width"  ||
                        row.key === "js-cart-height"
                    ) {
                        value = String(value).replace(/\s+/g, " ");
                    }

                    td.textContent = value || "-";
                }

                tr.appendChild(td);
            });

            tableBody.appendChild(tr);
        });
    }


    function hideEmptyShowItems(): void {
        if (emptyContainer) {
            emptyContainer.classList.add("hidden");
            (emptyContainer as HTMLElement).style.display = "none";
        }
        if (itemsContainer) {
            itemsContainer.classList.remove("hidden");
            (itemsContainer as HTMLElement).style.display = "flex";
        }
        if (diffWrapper) {
            diffWrapper.style.display = "block";
        }
    }

    function showEmptyHideItems(): void {
        if (itemsContainer) {
            itemsContainer.innerHTML = "";
            itemsContainer.classList.add("hidden");
            (itemsContainer as HTMLElement).style.display = "none";
        }
        if (diffWrapper) {
            diffWrapper.style.display = "none";
        }
        if (emptyContainer) {
            emptyContainer.classList.remove("hidden");
            (emptyContainer as HTMLElement).style.display = "block";
        }
    }

    function renderSkeletonCards(count: number): void {
        if (!itemsContainer) return;
        itemsContainer.innerHTML = "";

        for (let i = 0; i < count; i++) {
            const skeletonCard = `
<div class="item skeleton">
  <div class="image"></div>
  <div class="bottom-content">
    <div class="description">
      <div class="name"></div>
      <div class="price"></div>
      <div class="old-price"></div>
    </div>
    <div class="footer">
      <button class="in-cart"></button>
      <button class="buy-one-click"></button>
    </div>
  </div>
</div>`;
            itemsContainer.insertAdjacentHTML("beforeend", skeletonCard);
        }
    }

    function formatPrice(value?: string): string {
        const num = parseFloat(value || "0");
        if (isNaN(num)) return "";
        return num
            .toFixed(2)               // 5125.2 -> "5125.20"
            .replace(/\B(?=(\d{3})+(?!\d))/g, " "); // "5 125.20"
    }

    function renderDiffItemsFromObj(diffObj: Record<string, DiffItem>): void {
        if (!itemsContainer) return;

        itemsContainer.innerHTML = "";
        const ids = Object.keys(diffObj || {});

        if (ids.length === 0) {
            showEmptyHideItems();
            return;
        }

        hideEmptyShowItems();

        ids.forEach(id => {
            const item = diffObj[id];
            if (!item) return;

            const formattedPrice = formatPrice(item["js-cart-price"]);
            const unit = item["js-cart-unit-price"] || "шт.";

            const card = `
<div class="item js-product-item" data-js-product-id="${id}">
  <input type="hidden" class="js-cart-title" value="${item["js-cart-title"] || ""}">
  <input type="hidden" class="js-cart-href" value="${item["js-cart-href"] || ""}">
  <input type="hidden" class="js-cart-sku" value="${item["js-cart-sku"] || ""}">
  <input type="hidden" class="js-cart-price" value="${item["js-cart-price"] || ""}">
  <input type="hidden" class="js-cart-width" value="${item["js-cart-width"] || ""}">
  <input type="hidden" class="js-cart-height" value="${item["js-cart-height"] || ""}">
  <input type="hidden" class="js-cart-weight" value="${item["js-cart-weight"] || ""}">
  <input type="hidden" class="js-cart-length" value="${item["js-cart-length"] || ""}">
  <input type="hidden" class="js-cart-minimum" value="${item["js-cart-minimum"] || ""}">
  <input type="hidden" class="js-cart-unit-price" value="${item["js-cart-unit-price"] || ""}">

  <div class="image">
    <a href="${item["js-cart-href"] || ""}">
      <img class="js-cart-main-image" src="${item["js-cart-main-image"] || ""}" alt="" />
    </a>
    <div class="labels">
        <div class="labels-top">
            <div class="label-left">
                <div class="label-new">Новинка</div>
                <div class="label-action">Акция</div>
            </div>
            <div class="label-right">
                <div class="label-diff">
                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2672_7508)">
                    <path d="M14.7676 0.00341797H17.9997V14.9867H14.7676V0.00341797Z" fill="white"/>
                    <path d="M8.14777 15.0001H4.91406V1.68506H8.14777V15.0001Z" fill="white"/>
                    <path d="M13.0696 15.0002H9.83594V5.02832H13.0696V15.0002Z" fill="white"/>
                    <path d="M0 8.35645H3.22879V15.0002H0V8.35645Z" fill="white"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_2672_7508">
                    <rect width="18" height="15" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="label-hit">Хит</div>
    </div>
  </div>
  <div class="bottom-content">
    <div class="description top">
      <div class="name title">
            <a href="${item["js-cart-href"] || ""}">${item["js-cart-title"] || ""}</a>
        </div>
      <div class="price">${formattedPrice ? `${formattedPrice}₽/${unit}` : ""}</div>
      <div class="old-price">${item["js-cart-old-price"] || ""}</div>
    </div>
    <div class="footer">
      <button class="in-cart cart-v2">В корзину</button>
      <button class="buy-one-click js-buy-one-click-v2">Купить в 1 клик</button>
    </div>
  </div>
</div>`;
            itemsContainer.insertAdjacentHTML("beforeend", card);
        });

        renderSelectedCharacteristicsTable(diffObj);
    }

    function renderDiffItemsFromLocalStorage(): void {
        const storedCart = localStorage.getItem("diff");
        if (!storedCart) {
            showEmptyHideItems();
            return;
        }

        let diffObj: Record<string, DiffItem>;
        try {
            diffObj = JSON.parse(storedCart) as Record<string, DiffItem>;
        } catch {
            showEmptyHideItems();
            return;
        }

        if (!diffObj || Object.keys(diffObj).length === 0) {
            showEmptyHideItems();
            return;
        }

        renderDiffItemsFromObj(diffObj);
    }

    function clearAllDiff(): void {
        localStorage.removeItem("diff");
        renderDiffItemsFromLocalStorage();
    }

    document.addEventListener("click", e => {
        const deleteAllTarget = (e.target as HTMLElement | null)?.closest(".js-delete-all");
        if (deleteAllTarget) {
            e.preventDefault();
            clearAllDiff();
            return;
        }

        // удаление по клику на label-diff
        const diffTarget = (e.target as HTMLElement | null)?.closest(".label-diff");
        if (diffTarget) {
            e.preventDefault();
            e.stopPropagation();

            const item = diffTarget.closest(".js-product-item");
            if (!item) return;

            const productId = item.getAttribute("data-js-product-id");
            if (!productId) return;

            const storedDiff = localStorage.getItem("diff") || "{}";
            let diffObj: Record<string, DiffItem>;

            try {
                diffObj = JSON.parse(storedDiff) as Record<string, DiffItem>;
            } catch {
                diffObj = {};
            }

            delete diffObj[productId];

            const keys = Object.keys(diffObj);

            if (keys.length === 0) {
                localStorage.removeItem("diff");
                showEmptyHideItems();
            } else {
                localStorage.setItem("diff", JSON.stringify(diffObj));
                renderDiffItemsFromObj(diffObj);
            }
            return;
        }
    });

    (function init() {
        const params = new URLSearchParams(window.location.search);
        const share = params.get("share");

        if (share) {
            if (!diffWrapper) return;

            renderSkeletonCards(4);

            fetch(`/index.php?route=ajax/ajax/getProducts&share=${encodeURIComponent(share)}`, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                },
            })
                .then(r => r.json())
                .then((data: Record<string, DiffItem>) => {
                    const ids = Object.keys(data || {});
                    const totalCountEl = document.querySelector(".total-count") as HTMLElement | null;
                    if (totalCountEl) {
                        totalCountEl.textContent = String(ids.length);
                    }

                    if (ids.length === 0) {
                        showEmptyHideItems();
                        return;
                    }

                    diffWrapper.style.display = "block";
                    if (emptyContainer) {
                        emptyContainer.style.display = "none";
                        emptyContainer.classList.add("hidden");
                    }

                    renderDiffItemsFromObj(data);
                })
                .catch(err => {
                    console.error("getProducts error:", err);
                    renderDiffInitFromLocal();
                });

            return;
        }

        renderDiffInitFromLocal();
    })();

    function renderDiffInitFromLocal(): void {
        const storedCart = localStorage.getItem("diff");
        let count = 0;

        if (storedCart) {
            try {
                const diffObj = JSON.parse(storedCart) as Record<string, unknown>;
                count = Object.keys(diffObj || {}).length;
            } catch {
                count = 0;
            }
        }

        const totalCountEl = document.querySelector(".total-count") as HTMLElement | null;
        if (totalCountEl) {
            totalCountEl.textContent = String(count);
        }

        if (!diffWrapper) return;

        if (count === 0) {
            showEmptyHideItems();
            return;
        }

        diffWrapper.style.display = "block";

        renderSkeletonCards(count || 4);
        setTimeout(renderDiffItemsFromLocalStorage, 2000);
    }
}

registerInit(initDifference);
